import { render, staticRenderFns } from "./ImagePicture.vue?vue&type=template&id=b0df1316&scoped=true&"
import script from "./ImagePicture.vue?vue&type=script&lang=js&"
export * from "./ImagePicture.vue?vue&type=script&lang=js&"
import style0 from "./ImagePicture.vue?vue&type=style&index=0&id=b0df1316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0df1316",
  null
  
)

export default component.exports